import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetKidneyGauge() {

  return (

      <GaugeWithNeedle realAge={57} chronologicalAge={62} />
    
  );
};




